import * as classNames from 'classnames';
import { i18n } from '../../../i18n/i18n';
import * as Moment from 'moment';
import * as React from 'react';
import style from './WTableFilterDatum.less';
import { WDatepicker } from '../../forms/WDatepicker';

interface WTableFilterDatumProps extends React.ClassAttributes<any> {
    mode: string;
    onChange: (stamp: any) => void;
}
interface WTableFilterDatumState {
    filterShowing: boolean;
    stampVon: number;
    stampBis: number;
    pageY?: number;
    pageX?: number;
    clicked?: boolean;
}

class WTableFilterDatum extends React.Component<WTableFilterDatumProps, WTableFilterDatumState>  {
    constructor(props: any) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.rendenInfo = this.rendenInfo.bind(this);

        this.state = {
            filterShowing: false,
            stampVon: null,
            stampBis: null
        };
    }

    onChange(stamp: any) {
        this.setState({
            stampVon: stamp.von,
            stampBis: stamp.bis
        });
        if (stamp.von !== null && stamp.bis !== null) {
            this.setState({ filterShowing: false, pageY: undefined, pageX: undefined, clicked: false });
        }
        this.props.onChange(stamp);
    }

    onReset() {
        this.setState({
            stampVon: 0,
            stampBis: 0
        });
        this.props.onChange(null);
    }

    rendenInfo() {
        if (!this.state.stampVon || !this.state.stampBis ) {
            return '';
        } else {
            const strVon = Moment(this.state.stampVon * 1000).format('DD.MM.YYYY');
            const strBis = Moment(this.state.stampBis * 1000).format('DD.MM.YYYY');
            if (strVon !== strBis) {
                return strVon + ' - ' + strBis;
            } else {
                return strVon;
            }
        }
    }

    render() {
        let pageX = this.state.pageX;
        pageX = (pageX + 340) > window.innerWidth ? window.innerWidth - 350 : pageX;
        return (
            <div
                style={{ overflow: 'visible' }}
                onMouseEnter={(e: any) => {
                    const pageY = this.state.pageY ? this.state.pageY : e.target.offsetParent.getBoundingClientRect().top + 20;
                    const pageXTocheck = this.state.pageX ? this.state.pageX : e.target.offsetParent.getBoundingClientRect().left;
                    this.setState({
                        filterShowing: true,
                        pageY,
                        pageX: pageXTocheck
                    });
                }}
                onMouseLeave={(event) => {
                    if (event.relatedTarget === window) {
                        // when the mouse enters the options it will fire first as 'out' and then as 'in' again.
                        return;
                    }
                    this.setState({ filterShowing: false, pageY: undefined, pageX: undefined });
                }}
                className={style.wrapper}
            >
                <div className={style.info}>
                    <button className={style.reset} onClick={this.onReset} title={i18n('Filter zurücksetzen', 'sys')}>x</button>
                    <span>
                        {this.rendenInfo()}
                    </span>
                </div>
                {
                    this.state.filterShowing &&
                    <div className={this.state.clicked ? classNames(style.floatbox, style.active) : style.floatbox}
                        style={{ top: this.state.pageY.toString() + 'px', left: pageX.toString() + 'px' }}
                        onClick={() => this.setState({ clicked: true })}
                        onMouseLeave={(event: any) => {
                            if (event.relatedTarget === window) {
                                // when the mouse enters the options it will fire first as 'out' and then as 'in' again.
                                return;
                            }
                            this.setState({ filterShowing: false, pageY: undefined, pageX: undefined });
                        }}
                    >
                        <WDatepicker
                            style={style}
                            mode={this.props.mode}
                            stampVon={this.state.stampVon}
                            stampBis={this.state.stampBis}
                            forcePlausibel={true}
                            extendedOptions={true}
                            onChange={this.onChange}
                        />
                    </div>
                }
            </div>
        );
    }
}

export function generateDatumFilter(mode: string, beispiel: JSX.Element, onChange: (stamp: any) => void) {
    return (
        <div>
            <WTableFilterDatum
                mode={mode}
                onChange={onChange}
            />
            {beispiel}
        </div>
    );
}
